// extracted by mini-css-extract-plugin
module.exports = {"searchBox":"searchBox__searchBox___3yKJr","placeHolderShimmer":"searchBox__placeHolderShimmer___OcHll"};